import { memo } from 'react';
import { Slider } from '@music-vine/cadence/ui';
import { cn } from '@/lib/utils';
interface SeekSliderProps {
  max: number;
  onSeekChange: (value: number[]) => void;
  value: number;
}
const SeekSlider = memo(({
  value,
  max,
  onSeekChange
}: SeekSliderProps) => <div className={cn('flex w-full flex-col items-center justify-center gap-2')}>
    <div className={cn('w-full rounded-lg px-1 py-3 transition-opacity')}>
      <div className="w-full">
        <Slider aria-label="Seek slider" defaultValue={[0]} disabled={!max} max={max} min={0} onValueChange={onSeekChange} orientation="horizontal" step={0.001} value={[value]} />
      </div>
    </div>
  </div>);
SeekSlider.displayName = 'SeekSlider';
export default SeekSlider;